export default {
	computed: {
		canCreate() {
			return this.validatePermission(['integration.create']);
		},
		canDelete() {
			return this.validatePermission(['integration.delete']);
		},
		canUpdate() {
			return this.validatePermission(['integration.update']);
		}
	},
	methods: {
		isAuthorized(source) {
			let authorized = false;

			if (source.id) {
				authorized = this.validatePermission(
					['integration.update'],
					true
				);
			} else {
				authorized = this.validatePermission(
					['integration.create'],
					true
				);
			}

			return authorized;
		}
	}
};
